var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 212",
    width: 212,
    height: 212,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vecteezy_icon-media-social-facebook_22257063-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m124.9 49.1c-0.1 9.6-0.2 20.3-0.4 30.3 6.6 0 29.6-0.9 34.1 0.7 0.8 3.2-5 28.8-6.2 36.2l-28.6 0.1-0.1 89.6h-38.1c-0.1 0-1-89.9-1-89.9l-32.9-0.1 0.5-35.6 32.6-0.1 0.3-33.3c2.5-43.1 34.5-42.5 74.2-40.3l0.2 30.1c-12 0.4-34.6-1.6-34.6 12.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.22a0b38164088dc473b5798a94f2e971.svg";
export { ForwardRef as ReactComponent };